import { extendTheme, ThemeOverride } from '@chakra-ui/react'
import Button from './components/button'
import Checkbox from './components/checkbox'
import FormLabel from './components/formLabel'
import Input from './components/input'
import Modal from './components/modal'
import Popover from './components/Popover'
import Radio from './components/radio'
import Select from './components/select'
import Spinner from './components/spinner'
import StatusTrackerStep from './components/StatusTrackerStep'
import Table from './components/table'
import Textarea from './components/textarea'
import Tooltip from './components/tooltip'
import bodyFont from './css/body'
import datePicker from './css/datePicker'
import colors from './foundations/colors'
import sizes from './foundations/sizes'
import typography from './foundations/typography'
import Form from './components/form'
import Tabs from './components/tabs'

const overrides: ThemeOverride = {
  colors,
  styles: {
    global: {
      ...bodyFont,
      ...datePicker,
    },
  },
  sizes,
  ...typography,
  components: {
    Button,
    Checkbox,
    FormLabel,
    Form,
    Input,
    Modal,
    Radio,
    Select,
    Spinner,
    Table,
    StatusTrackerStep,
    Popover,
    Tabs,
    Tooltip,
    Textarea,
  },
}
export default extendTheme(overrides)
